import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { EnergyProgramComponent } from './forms/energy-program/energy-program.component';
import { EfficiencyAwardsComponent } from './forms/efficiency-awards/efficiency-awards.component';
import { RequestInformationComponent } from './forms/request-information/request-information.component';
import { TaxApplicationComponent } from './forms/tax-application/tax-application.component';
import { FranchiseComponent } from './forms/video-survey/franchise/franchise.component';
import { ProviderComponent } from './forms/video-survey/provider/provider.component';
import { ArmccmComponent } from './forms/armccm/armccm.component';
import { LeoComponent } from './forms/leo/leo.component';
// import { RedirectComponent } from './forms/redirect/redirect.component';
import { ComplaintsComponent } from './forms/complaints/complaints.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'forms-home',
    pathMatch: 'full',
    data: { title: 'Home' }
  },
  {
    path: 'forms-home',
    component: HomeComponent,
    data: { title: 'Home' }
  },
    //Remove the first three forms at the request of the client
  //   Work Request 152836
  //Complaint was re-written. 
  //   Work Request 150419
  //{
  //  path: 'energy-planning',
  //  component: EnergyProgramComponent,
  //  data: { title: 'State Energy Program Planning RFI' }
  //},
  //{
  //  path: 'efficiency-awards',
  //  component: EfficiencyAwardsComponent,
  //  data: { title: 'Economic Leaders in Energy Efficiency' }
  //},
  //{
  //  path: 'request-information',
 //   component: RequestInformationComponent,
  //  data: { title: 'Hear From Us' }
  //},
  //{
  //  path: 'complaint',
  //  component: ComplaintsComponent,
  //  data: { title: 'Damage Prevention Complaint Form' }
  //},
  {
    path: 'tax-credit',
    component: TaxApplicationComponent,
    data: { title: 'LCSA Tax Credit Application' }
  },
  {
    path: 'video-survey/provider',
    component: ProviderComponent,
    data: { title: 'Video Survey Provider' }
  },
  {
    path: 'video-survey/franchise',
    component: FranchiseComponent,
    data: { title: 'Video Survey Franchise' }
  },
  {
    path: 'armccm',
    component: ArmccmComponent,
    data: { title: 'Armccm' }
  },
  {
    path: 'leo',
    component: LeoComponent,
    data: { title: 'Legally Enforceable Obligation (LEO)' }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {})
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
